<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="accordion-container flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="mb-4 text-2xl text-dark-blue">Verify Account</h3>
        <p class="mb-4 text-left text-1md text-body-color">
          Please contact an authorized representative of the carrier with access
          to a publicly registered FMCSA contact method.
        </p>
        <p class="mb-4 text-left text-1md text-body-color">
          For further assistance, call us at 906-HIGHWAY or email us at
          service@highway.com.
        </p>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';

export default {
  name: 'VerifyAccount',
  components: {
    Modal,
  },
  props: {
    visible: Boolean,
  },
  emits: ['close'],
  data() {
    return {
      message: '',
      showItem: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.showItem = !this.showItem;
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .accordion-container {
    width: 500px;
  }
}
</style>
